<template>
<div>
    <v-dialog v-model="addBridgeItem" max-width="750px" persistent>
          <v-card flat color="white">
              <v-toolbar flat class="primary">
        <h1 class="headline white--text" >{{item.type}} Bridge Template</h1>
        <v-spacer></v-spacer>
        <v-btn flat color="white" class="white--text" @click="addBridgeItem=false, item={}">X</v-btn>
        </v-toolbar>
            <v-card-text>
              <v-layout justify-center>
                <v-flex xs4 mx-1>
                  <v-autocomplete ref="deviceMake" v-on:blur="$refs['deviceMake'].blur()" @change="validationCheck(item.customerOrganisationId)" v-if="item.type=='Add'" :items="deviceMakes" v-model="item.deviceMakeId" item-text="name" item-value="id" label="Device Make"></v-autocomplete>
                  <v-autocomplete ref="deviceMake" v-on:blur="$refs['deviceMake'].blur()"  @change="validationCheck(item.customerOrganisationId)" v-else-if="item.type=='Edit'" disabled :items="deviceMakes" v-model="item.deviceMakeId" item-text="name" item-value="id" label="Device Make"></v-autocomplete>
                </v-flex>
                <v-flex xs4 mx-1>
                  <v-select v-if="item.deviceMakeId" :disabled="item.type=='Edit'" :items="item.existingBridgeTemplates?policyTypes.filter(x=>x.value==='Management'||!item.existingBridgeTemplates.filter(z=>z.deviceMakeId==item.deviceMakeId).map(y=>y.type).includes(x.value)):policyTypes" label="Template Policy Type" item-text="name" item-value="value" v-model="item.policyType"></v-select>
                </v-flex>
              </v-layout>
              <div v-if="item.deviceMakeId&&!item.valid&&item.type=='Add'">
                <v-layout align-center justify-center>
                  <v-flex xs10 mx-1>
                    <h4 class="red--text">Both One Device & Two Device Policy templates have been assigned to this device make.</h4>
                  </v-flex>
                </v-layout>
              </div>
              <div v-if="item.deviceMakeId">
                 <v-flex v-if="item.deviceMakeId&&deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Zhone'">
                <!-- Port Info -->
                <v-layout justify-center>
                    <v-flex xs12>
                        <h3>Port</h3>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs6 mx-1>
                        <v-checkbox label="Auto Select Gem Port ID" v-model="item.autoSelectGemPortValue"></v-checkbox>
                </v-flex>
                    <v-flex xs6 mx-1>
                        <v-autocomplete ref="gponTrafficIndex" v-on:blur="$refs['gponTrafficIndex'].blur()" v-model="item.gponTrafficIndex" :items="zhoneTrafficProfiles" label="GTP Index" item-text="name" item-value="name"></v-autocomplete>
                    </v-flex>
                </v-layout>

                <!-- GTP Info -->
                <v-layout justify-center>
                    <v-flex xs12>
                        <h3>Bridge Logical</h3>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs4>
                        <v-autocomplete ref="bridgeTemplates" v-on:blur="$refs['bridgeTemplates'].blur()" clearable :items="bridgeTemplates" v-model="item.bridgeTemplateName" item-text="name" item-value="name" label="Bridge Logical Template"></v-autocomplete>
                    </v-flex>
                    <v-flex xs4 mx-1>
                    <v-autocomplete ref="outerVlan" v-on:blur="$refs['outerVlan'].blur()" clearable :items="vlanArray"  type="number" :min="0" v-model="item.outerVlan" label="Outer Vlan"></v-autocomplete>
                </v-flex>
                  <v-flex xs4 mx-1>
                    <v-autocomplete ref="innerVlan" v-on:blur="$refs['innerVlan'].blur()" clearable  :items="vlanArray" :min="0" v-model="item.innerVlan" label="Inner Vlan"></v-autocomplete>
                </v-flex>
                </v-layout>

                <v-layout justify-center>
                    <v-flex xs12>
                        <h3>CPE Connection</h3>
                    </v-flex>
                </v-layout>
                 <v-layout>
                    <v-flex xs6 mx-1>
                    <v-autocomplete ref="tpType" v-on:blur="$refs['tpType'].blur()" clearable :items="tpTypeArray" item-text="name" item-value="id"  v-model="item.tpType" label="Type"></v-autocomplete>
                </v-flex>
                      <v-flex xs6 mx-1>
                    <v-autocomplete ref="tpIndex" v-on:blur="$refs['tpIndex'].blur()" type="number" clearable :items="ports" chips v-model="item.tpIndex" label="Ethernet Port"></v-autocomplete>
                </v-flex>
                </v-layout>
                 <v-layout wrap>
               <v-flex xs6 mx-1>
                    <v-autocomplete ref="rgModeArray" v-on:blur="$refs['rgModeArray'].blur()" clearable :items="rgModeArray" item-text="name" item-value="id"  v-model="item.rgMode" label="RG Mode"></v-autocomplete>
                </v-flex>
               <v-flex xs4 mx-1>
                    <v-autocomplete ref="uniVlan" v-on:blur="$refs['uniVlan'].blur()" clearable :items="vlanArray" :min="0" v-model="item.uniVlan" label="Uni Vlan"></v-autocomplete>
                </v-flex>
                <v-flex xs4 mx-1>
                    <v-autocomplete ref="uniSlan" v-on:blur="$refs['uniSlan'].blur()" clearable :items="vlanArray" :min="0" v-model="item.uniSlan" label="Uni Slan"></v-autocomplete>
                </v-flex>
                 <v-flex xs4 mx-1>
                      <v-autocomplete ref="connectionType" v-on:blur="$refs['connectionType'].blur()" :items="connectionTypes" v-model="item.connectionType" item-text="name" item-value="value" label="Connection Type"></v-autocomplete>
                </v-flex>

                 <v-flex xs2 mx-1>
                  <v-checkbox label="Billable VLAN" v-model="item.isBillable"></v-checkbox>
                </v-flex>
               
                </v-layout>
                
              </v-flex>

              <!-- <v-flex v-if="item.deviceMakeId&&(deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Huawei'||deviceMakes.find(x=>x.id===item.deviceMakeId).name=='BDCOM')"> -->
              <v-flex v-if="item.deviceMakeId&&(deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Huawei'||deviceMakes.find(x=>x.id===item.deviceMakeId).name=='BDCOM'||deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Ubiquiti'||deviceMakes.find(x=>x.id===item.deviceMakeId).name=='MikroTik')">
                <v-layout justify-center>
                    <v-flex xs12>
                        <h3>Provisioning Settings</h3>
                    </v-flex>
                </v-layout>
                 <v-layout justify-center wrap>
                   <v-flex xs4 mx-1>
                      <v-autocomplete ref="innerVlan" v-on:blur="$refs['innerVlan'].blur()" clearable :items="vlanArray" v-model="item.innerVlan" label="Inner VLAN"></v-autocomplete>
                </v-flex>
                 <v-flex xs4 mx-1>
                      <v-autocomplete ref="outerVlan" v-on:blur="$refs['outerVlan'].blur()" clearable :items="vlanArray" v-model="item.outerVlan" label="Outer VLAN"></v-autocomplete>
                </v-flex>
                 <v-flex xs4 mx-1>
                      <v-autocomplete ref="userVlan" v-on:blur="$refs['userVlan'].blur()" clearable :items="vlanArray" v-model="item.uniVlan" label="User VLAN"></v-autocomplete>
                </v-flex>
                 <v-flex xs4 mx-1>
                      <v-autocomplete ref="gemportId" v-on:blur="$refs['gemportId'].blur()" clearable :items="vlanArray" v-model="item.gemportId" label="Gemport ID"></v-autocomplete>
                </v-flex>
                   <v-flex xs4 mx-1>
                      <v-autocomplete ref="translateTypes" v-on:blur="$refs['translateTypes'].blur()" clearable :items="translateTypes" v-model="item.translationType" item-text="name" item-value="name" label="Tag Transform Type"></v-autocomplete>
                </v-flex>
                   <v-flex xs4 mx-1>
                      <v-checkbox label="Billable VLAN" v-model="item.isBillable"></v-checkbox>
                </v-flex>
                 </v-layout>
                 <v-layout justify-center v-if="item.policyType=='OneDevice'">
                    <v-flex xs12>
                        <h3>Configuration Settings</h3>
                    </v-flex>
                </v-layout>
                 <v-layout justify-center wrap v-if="item.policyType=='OneDevice'">
                   <v-flex xs4 mx-1>
                      <v-autocomplete ref="connectionType" v-on:blur="$refs['connectionType'].blur()" :items="connectionTypes" v-model="item.connectionType" item-text="name" item-value="value" label="Connection Type"></v-autocomplete>
                </v-flex>
                    <v-flex xs4 mx-1>
                      <v-autocomplete ref="innerVlan" v-on:blur="$refs['innerVlan'].blur()" clearable :items="vlanArray" :min="0" v-model="item.innerVlan" label="Vlan"></v-autocomplete>
                </v-flex>
                  <v-flex xs8 mx-1>
                    <v-layout>
                      <v-switch v-model="item.port_1" label="Port 1"></v-switch>
                    <v-switch v-model="item.port_2" label="Port 2"></v-switch>
                    <v-switch v-model="item.port_3" label="Port 3"></v-switch>
                    <v-switch v-model="item.port_4" label="Port 4"></v-switch>
                    </v-layout>
                    

                    <!-- <v-autocomplete ref="testMenu" v-on:blur="$refs['testMenu'].blur()":items="ports" chips multiple v-model="item.tpIndex" label="Ethernet Port(s)"></v-autocomplete> -->
                </v-flex>
                </v-layout>
              </v-flex>
                
              </div>
              
             
               
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn v-if="item.type=='Add'&&item.policyType&&item.deviceMakeId&&deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Zhone'&&item.tpType&&item.deviceMakeId&&item.bridgeTemplateName&&item.rgMode&&item.gponTrafficIndex" class="primary white--text" round @click="saveBridgeItem()">Save Template</v-btn>
                    <v-btn v-else-if="item.type=='Edit'&&item.policyType&&item.deviceMakeId&&deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Zhone'&&item.tpType&&item.deviceMakeId&&item.bridgeTemplateName&&item.rgMode&&item.gponTrafficIndex" class="primary white--text" round @click="updateBridgeItem()">Save Template</v-btn>
                    <v-btn v-else-if="item.type=='Add'&&item.policyType&&item.deviceMakeId&&(deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Huawei'||deviceMakes.find(x=>x.id===item.deviceMakeId).name=='BDCOM'||deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Ubiquiti')&&item.innerVlan != 0" class="primary white--text" round @click="saveBridgeItem()">Save Template</v-btn>
                    <v-btn v-else-if="item.type=='Edit'&&item.policyType&&item.deviceMakeId&&(deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Huawei'||deviceMakes.find(x=>x.id===item.deviceMakeId).name=='BDCOM'||deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Ubiquiti')&&item.innerVlan != 0" class="primary white--text" round @click="updateBridgeItem()">Save Template</v-btn>
                    <v-btn v-else-if="item.type=='Add'&&item.policyType&&item.deviceMakeId&&((deviceMakes.find(x=>x.id===item.deviceMakeId).name=='MikroTik') || (deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Mikrotik'))"  class="primary white--text" round @click="saveBridgeItem()">Save Template</v-btn>
                    <v-btn v-else-if="item.type=='Edit'&&item.policyType&&item.deviceMakeId&&((deviceMakes.find(x=>x.id===item.deviceMakeId).name=='MikroTik') || (deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Mikrotik'))"  class="primary white--text" round @click="updateBridgeItem()">Save Template</v-btn>
                    <v-btn v-else disabled class="primary white--text" round >Save Template</v-btn>
                </v-layout>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      
      <v-toolbar flat color="white"><v-spacer></v-spacer><v-text-field v-model="search" label="Search"></v-text-field></v-toolbar>
      <div v-if="loaded">
        <v-data-table
       :key="loadingKey"
        :headers="orgHeaders"
        
        class="elevation-1"
        :search="search"
        :items="organisations"
        :rows-per-page-items="[25, 50, 100, 250]"
        item-key="id"
        align-center
        :expand="true"
        style="cursor: pointer"
        
      >
      <template v-slot:items="props">
          <tr v-if="props.item.bridgeTemplates.length>0" @click="props.expanded = !props.expanded" :key="loadingKey">
            <td class="text-xs-left align-center"  v-if="props.item.bridgeTemplates.length>0">
              <v-icon v-if="!props.expanded" class="justify-center">chevron_right</v-icon>
              <v-icon v-else>keyboard_arrow_down</v-icon>
              {{props.item.name}}
            </td>
          <td class="text-xs-center">{{props.item.bridgeTemplates.length}}</td>
          <td class="text-xs-center"><v-chip color="blue" class="white--text" v-for="make in props.item.deviceMakes" :key="make">{{make}}</v-chip></td>
          </tr>
          <tr v-else>
             <td class="text-xs-left"><v-icon color="light-green" @click="addBridgeModal(props.item)">add_circle</v-icon> {{props.item.name}}</td>
          <td class="text-xs-center">{{props.item.bridgeTemplates.length}}</td>
          <td class="text-xs-center"><v-chip color="blue" class="white--text" v-for="make in props.item.deviceMakes" :key="make">{{make}}</v-chip></td>
          </tr>
        </template>
        <template  v-slot:expand="props">
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn round color="primary" @click="addBridgeModal(props.item)"><v-icon color="white">add_circle</v-icon></v-btn>
          </v-toolbar>
           <v-data-table
            :items="props.item.bridgeTemplates"
            hide-actions
            :headers="templateHeaders"
            :rows-per-page-items="[25, 50, 100, 250]"
            :key="loadingKey"
            
          >
            <template v-slot:items="props">
              <td><v-layout justify-center align-center>
                 <v-icon small @click="editBridgeModal(props.item)">edit</v-icon>
                 <v-icon small @click="deleteBridgeItem(props.item)">delete</v-icon>
                </v-layout></td>
              <td class="text-xs-center">{{props.item.deviceMake.name}}</td>
              <td class="text-xs-center">
                <v-chip color="primary" class="white--text" v-if="props.item.type=='OneDevice'">1 Device Policy</v-chip>
                <v-chip color="primary" class="white--text" v-else-if="props.item.type=='TwoDevice'">2 Device Policy</v-chip>
                <v-chip color="primary" class="white--text" v-else>{{props.item.type}}</v-chip>
                </td>
                <td class="text-xs-center">{{props.item.innerVlan}}</td>
                <td class="text-xs-center">{{props.item.outerVlan}}</td>
                <td class="text-xs-center">
                  <v-icon v-if="props.item.isBillable" color="green">check_circle</v-icon>
                  <v-icon v-else color="red">cancel</v-icon>
                </td>
            </template>
           </v-data-table>
           </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
      </div>
      
  </div>
</template>
 
<script>
import Api from "@/services/Api";
export default {
  data() {
    return {
       organisationBridgeTemplates: [],
      item: {},
      ports: ['1', '2', '3', '4'],
      selectedPorts: [],
       addBridgeItem: false,
        vlanArray: this.range(0, 4095),
        bridgeTemplates: [],
        zhoneTrafficProfiles: [],
        deviceMakes: [],
        organisations: [],
        loadingkey: 0,
        loaded: false,
        connectionTypes: [
          {value: 'IPOE', name: 'IPoE'},
          {value: 'PPPOE', name: 'PPPoE'},
          {value: 'BRIDGE_PPPOE', name: 'Bridged PPPoE'},
          {value: 'BRIDGE_IPOE', name: 'Bridged IPoE'},
        ],
        policyTypes: [
          {value: 'OneDevice', name: 'One Device Policy'},
          {value: 'TwoDevice', name: 'Two Device Policy'},
          {value: 'Management', name: 'Management'},

        ],
        rgModeArray:[
            {id: 1, name: 'Routed'},
            {id: 2, name: 'BRouted'},
            {id: 3, name: 'rPPPoE'},
            {id: 4, name: 'bPPPoE'},
            {id: 5, name: 'Bridged'},
            {id: 6, name: 'Not Applicable'}

        ],
        translateTypes: [
                {id: 0, name: 'Default'},
                {id: 1, name: 'Transparent'},
                {id: 2, name: 'Translate'},
                {id: 3, name: 'Translate_And_Add'},
                {id: 4, name: 'Add_Double'},
                {id: 5, name: 'Translate_Double'},
                {id: 6, name: 'Translate_And_Remove'}
            ],
        tpTypeArray: [
            {id: 1, name: 'Ethernet UNI'},
            {id: 2, name: 'VCC Termination Point'},
            {id: 3, name: 'Mapper Service Profile'},
            {id: 4, name: 'IP Host Config Data'},
            {id: 5, name: 'GEM Interworking Termination Point'},
            {id: 6, name: 'Multicast GEM Interworking Termination Point'},
            {id: 7, name: 'xDSL UNI'},
            {id: 8, name: 'VDSL UNI'},
            {id: 9, name: 'Ether Flow Termination Point'},
            {id: 10, name: 'Physical Path UNI'},
            {id: 11, name: 'Physical Path RF Video UNI'},
            {id: 12, name: 'Physical Path IPTV UNI'},
            {id: 13, name: 'H248 Voice'},
            {id: 14, name: 'SIP Voice'},
            {id: 15, name: 'SIP PLAR Voice'},
            {id: 16, name: 'PWE Termination'},
            {id: 17, name: 'Virtual Ethernet'},
            {id: 18, name: 'dot11 Termination Point'},
            {id: 19, name: 'Fiber LAN Termination Point'},
            {id: 20, name: 'TR69 Termination Point'},
            {id: 21, name: 'Management Termination Point'},
            {id: 22, name: 'MGCP Voice Termination Point'}
        ],
    load:true,
    showDetails: true,
    isloading:true,
    vlanTypes: ['Business', 'Residential'],
    loading: false, 
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    orgHeaders: [
        {
          text: "Organisation",
          align: "center",
          value: "name"
        },{
          text: "Attached Templates",
          align: "center",
          sortable: false
        },
        {
          text: "Device Make Templates",
          align: "center",
          value: "deviceMakes"
        }
        ],
    templateHeaders: [
                {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Device Make",
          align: "center",
          value: "deviceMake.name"
        },
        {
          text: "Policy Template Type",
          align: "center",
          value: "type"
        },
        {
          text: "Inner VLAN",
          align: "center",
          value: "innerVlan"
        },
         {
          text: "Outer VLAN",
          align: "center",
          value: "outerVlan"
        },
        {
          text: "Billable",
          align: "center",
          value: "isBillable"
        }
      ],
    vlans: [],
    editedIndex: -1,
    editedItem: {
      description: "",
        serviceVlan: null,
        customerVlan: null,
        customer:null,
        customerOrganisationId: null,  
        gemPort: null,
        gemPortZhone: null,
        vlanType: null,
        isPrimaryVlan: false,       
        isActive: true,
        isDeleted: false
    },
    defaultItem: {
     description: "",
        serviceVlan: null,
        customerVlan: null,
        customer:null,
        customerOrganisationId: null,  
        gemPort: null,
        gemPortZhone: null,
        vlanType: null,
        isPrimaryVlan: false,          
        isActive: true,
        isDeleted: false
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
       this.pages=Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/vlans'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },
  methods: {
   async initialize() {
      await this.getOrgBridgeTemplates()
      
      this.getBridgeTemplates()
      this.getZhoneTrafficProfiles()
      this.getDeviceMakes()
       
    },
    async getConnectedOrganisations(){
      await Api().get('/organisationConnection').then(async response=>{
        let organisations = response.data.map(x=>x.connectedOrganisation)
        organisations.push(this.$store.state.currentOrg.org)
        // organisations.unshift(this.$store.state.currentOrg.org)
        for (let i=0; i<organisations.length;i++){
          organisations[i].bridgeTemplates = await this.organisationBridgeTemplates.filter(x=>x.customerOrganisationId===organisations[i].id)
          organisations[i].deviceMakes = [
            ...new Set(
              organisations[i].bridgeTemplates.map(
                item => item.deviceMake.name
              )
            )
          ];
          
          
          // organisations[i].bridgeTemplates.map(z=>z.deviceMake.name)
          
        }
        
        
        this.organisations = organisations
        this.loaded=true
            this.loadingkey+=1
           
      })
    },
    getOrgBridgeTemplates(){
      Api().get('/organisationBridgeTemplate')
      .then(async response=>{
        this.organisationBridgeTemplates=response.data
        // this.loadingkey+=1
        await this.getConnectedOrganisations()
      })
    },
    async getBridgeTemplates(){
      await Api()
      .get('/bridgeTemplate')
      .then(response=>{
       this.bridgeTemplates = response.data
      })
    },
  range(start, end) {
        return Array(end - start + 1).fill().map((_, idx) => start + idx)
        },
    async saveBridgeItem(){
      this.item.type = this.item.policyType
      await Api()
      .post('/organisationBridgeTemplate', this.item)
      .then(response=>{
        this.initialize()
        this.item={}
        this.addBridgeItem=false
      })
    },
    async addBridgeModal(item){
      if(this.authCreate(this.$store.state.currentRoute)){
              this.item={
                  type: 'Add',
                  customerOrganisationId: item.id,
                  deviceMakeId: null,
                  autoSelectGemPortValue: false,
                  innerVlan: null,
                  outerVlan: null,
                  uniVlan: null,
                  uniSlan: null,
                  // tpType: 1,
                  // tpIndex: 1,
                  // rgMode: 6,
                  // gponPortId: 0,
                  // gponTrafficIndex: "1100000000",
                  // bridgeTemplateName: "DownlinkSingleTagged",
                  existingBridgeTemplates: item.bridgeTemplates,
                  policyType: '',
                  port_1:  false,
                  port_2:  false,
                  port_3:  false,
                  port_4:  false,
                  isBillable: true,
                  valid: true
              }
              this.addBridgeItem=true
      }
        },
        async editBridgeModal(item){
         if(this.authUpdate(this.$store.state.currentRoute)){
              this.item={
                  type: 'Edit',
                  id: item.id,
                  deviceMakeId: item.deviceMakeId,
                  autoSelectGemPortValue: item.autoSelectGemPortValue,
                  innerVlan: item.innerVlan,
                  outerVlan: item.outerVlan,
                  uniVlan: item.uniVlan,
                  uniSlan: item.uniSlan,
                  tpType: item.tpType,
                  tpIndex: item.tpIndex,
                  rgMode: item.rgMode,
                  gponTrafficIndex: item.gponTrafficIndex,
                  bridgeTemplateName: item.bridgeTemplateName,
                  customerOrganisationId: item.customerOrganisationId,
                  policyType: item.type,
                  existingBridgeTemplates: item.bridgeTemplates,
                  connectionType: item.connectionType,
                  port_1:  item.port_1,
                  port_2:  item.port_2,
                  port_3:  item.port_3,
                  port_4:  item.port_4,
                  isBillable: item.isBillable,
                  translationType: item.translationType,
                  gemportId: item.gemportId,
                  valid: true
              }
              this.addBridgeItem=true
         }
        },
    async updateBridgeItem(){
      this.item.type = this.item.policyType
      await Api()
      .put('/organisationBridgeTemplate/'+this.item.id, this.item)
      .then(response=>{
        this.getOrgBridgeTemplates()
        this.item={}
        this.addBridgeItem=false
      })
    },
    async deleteBridgeItem(item){
      if(this.authDelete(this.$store.state.currentRoute)){
        confirm("Are you sure you would like to remove this template?")&&
      Api().put('/organisationbridgeTemplate/'+item.id, {
        isActive: false, isDeleted: true
      }).then(response=>{
        this.initialize()
      })
      }
      
    },
    async validationCheck(id){
      let orgTemplates = await this.organisations.find(x=>x.id == id)
      let templates = orgTemplates.bridgeTemplates.filter(y=>y.deviceMakeId == this.item.deviceMakeId)
      templates = templates.map(z=>z.type)
      if(templates.length>0&&templates.includes('OneDevice')&&templates.includes('TwoDevice')){
        this.item.valid = false
      } else {
        this.item.valid=true
      }
    },

    async getZhoneTrafficProfiles(){
      await Api()
      .get('/zhoneTrafficProfile')
      .then(response=>{
       this.zhoneTrafficProfiles = response.data
      })
    },
    async getDeviceMakes(){
      Api()
      .get('/deviceMakes')
      .then(response=>{
        this.deviceMakes = response.data
      })
    },
  }
};
</script>